import React, { useState, useEffect } from 'react';

import getSpeed from './getSpeed';

import './styles.css';

export default props => {
  const [count, setCount] = useState(0);
  const [speed, setSpeed] = useState(null);

  useEffect(() => {
    getSpeed().then(res => {
      setSpeed(res.speedMbps);

      setTimeout(() => {
        setCount(count + 1);
      }, 1000);
    });
  }, [count]);

  return (
    <div className="Tahometer" style={props.style}>
      <div className="Tahometer__title">Скорость интернета у вас сейчас</div>
      <div className="Tahometer__inner">
        {speed ? `${speed} ` : '...'}
        <br /> Мбит/с
      </div>
    </div>
  );
};
